import { Field, Label, Radio, RadioGroup } from "@headlessui/react";

import { JSX, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";

import { IconRadio } from "@/components/icons";

import { COLORS } from "@/config/colors.ts";
import { useGetPaymentMethods } from "@/hooks/api/user.hooks";
import { cn } from "@/utils/cn.ts";

export type TopUpOption = {
  slug: string;
  link: string;
  logo: string;
  type_logo: string | null;
  commission: string | null;
};

const TopUpForm = ({
  topUpOption,
  selectOption,
}: {
  topUpOption?: TopUpOption;
  selectOption: (option: TopUpOption) => void;
}): JSX.Element => {
  const { t } = useTranslation();
  const [params] = useSearchParams();

  const trId = useMemo(() => params.get("tr_id") ?? "", []);

  const { data: methods } = useGetPaymentMethods(+trId);

  return (
    <div>
      <Field as={"div"}>
        <Label className={"text-sm/4 font-semibold uppercase"}>{t("Payment.method")}</Label>
        {methods && (
          <RadioGroup
            value={topUpOption}
            onChange={selectOption}
            aria-label="Server size"
            className={"mt-6 grid grid-cols-2 gap-4 max-lg:grid-cols-1"}
          >
            {methods.map((option, index) => (
              <Radio
                key={option.slug}
                value={option}
                as={"div"}
                className={cn(
                  "relative flex cursor-pointer rounded-lg p-4 outline outline-1 -outline-offset-1 outline-surface-container transition-all",
                  "flex items-center gap-4",
                  "focus:outline-2 data-[checked]:outline-orange-1 data-[focus]:outline-white",
                  { "lg:col-span-2": index > 1 },
                )}
              >
                <IconRadio
                  color={topUpOption === option ? COLORS["orange-1"] : COLORS["surface-container"]}
                  aria-label={option.slug}
                  active={topUpOption === option}
                  className="size-6"
                />
                <div className="flex w-full items-center justify-between gap-4">
                  <span>
                    <img src={option.logo} alt={option.slug} className="h-auto max-w-full" />
                  </span>
                  {option.type_logo && (
                    <span>
                      <img src={option.type_logo} alt={option.slug} className="h-4 w-auto" />
                    </span>
                  )}
                </div>
              </Radio>
            ))}
          </RadioGroup>
        )}
      </Field>
    </div>
  );
};

export default TopUpForm;
